<template>
  <div class="animation-ai">
    <svg width="1.5rem" height="1.5rem" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <!-- 4방향 별 모양 (다이아몬드형) -->
        <path
          id="sparkle"
          d="M 0,-1 C 0.3,-0.3 0.3,-0.3 1,0 C 0.3,0.3 0.3,0.3 0,1 C -0.3,0.3 -0.3,0.3 -1,0 C -0.3,-0.3 -0.3,-0.3 0,-1 Z"
        />
      </defs>

      <!-- 왼쪽 위 작은 별 -->
      <g transform="translate(28, 24)">
        <use href="#sparkle" fill="#5486ff" transform="scale(16)">
          <animateTransform
            attributeName="transform"
            type="scale"
            values="0;16;12.8;16;16"
            dur="3.2s"
            :repeatCount="repeatCount"
          />
          <animate attributeName="opacity" values="0;1;0.6;1;1" dur="3.2s" :repeatCount="repeatCount" />
          <animate
            attributeName="fill"
            values="#2dc9c3;#4a8df2;#9278ec;#4a8df2"
            dur="3.2s"
            :repeatCount="repeatCount"
          />
        </use>
      </g>

      <!-- 오른쪽 큰 별 -->
      <g transform="translate(65, 50)">
        <use href="#sparkle" fill="#5b76ff" transform="scale(32)">
          <animateTransform
            attributeName="transform"
            type="scale"
            values="0;32;25.6;32;32"
            dur="3.2s"
            begin="0.3s"
            :repeatCount="repeatCount"
          />
          <animate attributeName="opacity" values="0;1;0.6;1;1" dur="3.2s" begin="0.3s" :repeatCount="repeatCount" />
          <animate
            attributeName="fill"
            values="#2dc9c3;#4a8df2;#9278ec;#4a8df2"
            dur="3.2s"
            begin="0.3s"
            :repeatCount="repeatCount"
          />
        </use>
      </g>

      <!-- 왼쪽 아래 중간 별 -->
      <g transform="translate(22, 72)">
        <use href="#sparkle" fill="#6e5bff" transform="scale(20)">
          <animateTransform
            attributeName="transform"
            type="scale"
            values="0;20;16;20;20"
            dur="3.2s"
            begin="0.6s"
            :repeatCount="repeatCount"
          />
          <animate attributeName="opacity" values="0;1;0.6;1;1" dur="3.2s" begin="0.6s" :repeatCount="repeatCount" />
          <animate
            attributeName="fill"
            values="#2dc9c3;#4a8df2;#9278ec;#4a8df2"
            dur="3.2s"
            begin="0.6s"
            :repeatCount="repeatCount"
          />
        </use>
      </g>
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed, withDefaults, defineProps } from 'vue';

const props = withDefaults(
  defineProps<{
    infinite?: boolean;
  }>(),
  { infinite: false }
);

// SMIL repeatCount는 "indefinite" 문자열이 필요
const repeatCount = computed(() => (props.infinite ? 'indefinite' : '1'));
</script>
